import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class NotificationMenuService {
  private _onMenuOpen$: Subject<void> = new Subject<void>();

  public onMenuOpen$: Observable<void> = this._onMenuOpen$.asObservable();


  public requestMenuOpen (): void {
    this._onMenuOpen$.next();
  }
}
